import * as lvFlandersBarNgCore from '../dist/@lvflanders/bar-ng';

// global glue variable for externals
if (window['lvflanders'] == null) window['lvflanders'] = <any>{};
if (window['lvflanders'].bar == null) window['lvflanders'].bar = <any>{};
if (window['lvflanders'].bar.ng == null) window['lvflanders'].bar.ng = <any>{};

window['lvflanders'].bar.ng.core = lvFlandersBarNgCore;

export { lvFlandersBarNgCore };